import { createI18n, LANG_LOCALE, LANG_NAMES, LANGS, type Lang, type Vars } from '@bak/admin-ui'

import { en, id, type MessageKey } from './messages/index.js'

// The CMS's translation layer: the shared factory bound to this app's catalogs (see packages/admin-ui/src/i18n-core.tsx).

export type { Lang, MessageKey, Vars }
export { LANG_LOCALE, LANG_NAMES, LANGS }
export type T = (key: MessageKey, vars?: Vars) => string

export const { I18nProvider, useT, useLang, translate, getLang } = createI18n<MessageKey>({ en, id }, { storageKey: 'bak-admin-lang' })
